enum ExternalProviderEnum {
    AzureAD = "aad",
    ADFS = "adfs"
};

export default ExternalProviderEnum;
